import { useEffect, useState } from "react";
import Typography from "components/Typography";
import floatButton from "./floatButton.png";

function ChatBubble({ onClick }: { onClick?: () => void }) {
  const [visible, setVisible] = useState(true);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  const expiredValidity = window.sessionStorage.getItem("expiredValidity");

  if (expiredValidity) return null;

  return (
    <div>
      <Typography
        onClick={onClick}
        className={`speech-bubble${visible || hovered ? "" : " speech-bubble--hidden"}`}
        color="white"
      >
        Olá, sou a PraxIA.
        <Typography component="span" display="block" color="white">
          Como posso te ajudar?
        </Typography>
      </Typography>
      <img
        src={floatButton}
        alt="Abrir assistente virtual"
        className="floatIaButton"
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      />
    </div>
  );
}
export default ChatBubble;
